import React, { useRef, useState } from 'react';
import { Popover } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

const PopoverMenu = ({ icon, children }) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const handleToggle = (openMenu) => {
    setOpen(openMenu);
    anchorRef.current.blur();
  };

  return (
    <>
      <IconButton edge="start" color="inherit" onClick={() => handleToggle(true)} ref={anchorRef}>
        {icon}
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorRef.current}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        autoFocus={false}
        onClose={() => anchorRef.current.blur()}
      >
        <ClickAwayListener onClickAway={() => handleToggle(false)}>
          <div onClick={() => handleToggle(false)}>{children}</div>
        </ClickAwayListener>
      </Popover>
    </>
  );
};

export default PopoverMenu;
